
import {
  UPDATE_GALLERY,
  PARSE_HARMONY_GALLERY,
  GET_GALLERY_WITH_FALLBACKS,
} from "./actionTypes";

export const updateGallery = ({ assets }) => ({
  type: UPDATE_GALLERY,
  assets,
});

export const parseHarmonyGallery = (assets) => ({
  type: PARSE_HARMONY_GALLERY,
  harmonyGallery: assets,
})

export const getGalleryWithFallbacks = () => ({
  type: GET_GALLERY_WITH_FALLBACKS
})

// const getDynamicGalleryImage = (productInfo, galleryData) => {
//   // need to read state from here so dynamic gallery updates properly
//   const attachmentItemIds = flow(
//     omit(['DefaultProduct', 'primary']),
//     map(p => p.itemId),
//   )(productInfo) || [];

//   const itemIds = compact([get(productInfo, 'primary.itemId'), ...attachmentItemIds.slice(0, 4)]);
//   let dynamicGalleryImage;

//   if (!isEmpty(itemIds)) {
//     dynamicGalleryApi(itemIds)
//       .then((image) => {
//         // if calling throws no errors setup url for dynamic gallery image
//         dynamicGalleryImage = {
//           id: 'dynamicGalleryImage',
//           sizes: ["145", "600", "1000"],
//           type: 'IMAGE',
//           url: `${config.customBaseUrl}/pipfigurator/api/dynamicgallery?${itemIds.map(x => `items=${encodeURIComponent(x)}`).join('&')}&hei=<SIZE>`,
//           primaryLink: `${config.customBaseUrl}/pipfigurator/api/dynamicgallery?${itemIds.map(x => `items=${encodeURIComponent(x)}`).join('&')}&hei=<SIZE>`,
//           thumbnail: `${config.customBaseUrl}/pipfigurator/api/dynamicgallery?${itemIds.map(x => `items=${encodeURIComponent(x)}`).join('&')}&hei=<SIZE>`,
//           source: "THD_DYNAMIC_GALLERY",
//         };
//       })
//       .catch((err) => {
//         // if no dynamic gallery image found fallback to gallery data
//         return galleryData;
//       });
//   }

//   return [galleryData, ...dynamicGalleryImage];
// }

const getGallery = () => (dispatch) => {
  // handled by gallerySaga
  dispatch(getGalleryWithFallbacks());
  // const {
  //   skuMap,
  //   product,
  //   configurator: { choices, options },
  //   product: {
  //     details: {
  //       visualizedSiteProductOptions,
  //       productId ,
  //       attributes: {
  //         dynamicGallery,
  //       },
  //     },
  //   },
  // } = getState();

  // if (typeof (productId) === 'undefined') return;

  // const searchToken = gallerySearchTokenGenerator(
  //   skuMap,
  //   product,
  //   choices,
  //   productId,
  //   options,
  //   visualizedSiteProductOptions
  // );

  // const folder = product?.details?.attributes?.scene7Folder;
  // if (!folder) {
  //   return;
  // }

  // return galleryApi(folder, searchToken).then((gallery) => {
  //   const galleryData = gallery.assets.map((x) => {
  //     const id = x.s3ObjectName;
  //     const url = x.primaryLink.replace("hei=1000", "hei=<SIZE>") || x.primaryLink.replace("hei=100", "hei=<SIZE>");
  //     const videoStill = x.mediaType === 'VIDEO' ? x.thumbnail : null;
  //     const sizes = ["145", "600", "1000"];

  //     return {
  //       id,
  //       sizes,
  //       type: x.mediaType,
  //       url,
  //       source: "CONFIGURABLE_S3",
  //       videoStill,
  //       primaryLink: x.primaryLink,
  //       thumbnail: x.thumbnail,
  //     };
  //   });

  //   const { productInfo } = getState();

  //   if (dynamicGallery) {
  //     dispatch(updateGallery({assets: [getDynamicGalleryImage(productInfo, galleryData)]}));
  //   } else {
  //     if (galleryData.length) {
  //       const isFullyVisualizedRegEx = new RegExp('^([0-9]{6,9})');

  //       isFullyVisualizedRegEx.test(_first(gallery.assets).s3ObjectName)
  //         ? dispatch(updateGallery({
  //           assets: [...galleryData]
  //         }))
  //         : dispatch(updateGallery({
  //           assets: [getDynamicGalleryImage(productInfo, galleryData)]
  //         }));
  //     }
  //   }
  //   const { gallery: { assets } } = getState();

  //   if (assets.length > 0) {
  //     dispatch({
  //       type: PARSE_HARMONY_GALLERY,
  //       harmonyGallery: [...assets],
  //     });
  //   }
  // });
};

export default getGallery;
